import createIcon from '../../createIcon';

/**
 * @component @name Backpack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOFYyMEMyMCAyMS4xIDE5LjEgMjIgMTggMjJINkM0LjkgMjIgNCAyMS4xIDQgMjBWOEM0IDYuMTQgNS4yOCA0LjU5IDcgNC4xNFYySDEwVjRIMTRWMkgxN1Y0LjE0QzE4LjcyIDQuNTkgMjAgNi4xNCAyMCA4Wk02IDEyVjE0SDE2VjE2SDE4VjEySDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Backpack = createIcon('Backpack', [
  [
    'path',
    {
      d: 'M20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V8C4 6.14 5.28 4.59 7 4.14V2H10V4H14V2H17V4.14C18.72 4.59 20 6.14 20 8ZM6 12V14H16V16H18V12H6Z',
      key: '1qfd0n',
    },
  ],
]);

export default Backpack;
